export default {
    methods: {
        formatPrice(price) {
            if(!price) return null;
            let parts = (price/100).toFixed(2).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            return price && `${parts.join(',')}&nbsp;€`;
        }
    }
}